// channelIdentifiers is edited as JSON text in the textarea. A read returns it
// DOUBLE-encoded (AWSJSON whose stored value is itself a JSON string, by design in
// billing-api resolve-channel-identifiers.ts), so a single parse yields a string and
// the schema rejected every listed row as "Must be a valid JSON object" (FNP-1899).
// Unwrap up to two hops, as the API and the aggregator do, and show readable JSON.
// The build helper re-parses on submit, and the API re-parses and re-serializes on
// every write, so the stored value is the same whichever encoding the form holds.
export const toFormChannelIdentifiers = (value: unknown): string => {
    let parsed: unknown = value;
    for (let hop = 0; hop < 2 && typeof parsed === 'string'; hop++) {
        try {
            parsed = JSON.parse(parsed);
        } catch {
            // Not JSON: show it as it is and let the schema say so.
            return value as string;
        }
    }
    if (parsed && typeof parsed === 'object') return JSON.stringify(parsed, null, 2);
    if (typeof value === 'string') return value;
    return '{}';
};
